module.exports = __webpack_public_path__ + "static/media/Image 61@2x.20dd8d84.png";